import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import QRCode from "react-qr-code";

const ShipmentPORPrint = ({ orderDetail: shipment }) => {
  const shipmentDetails = shipment;

  // Determine sender: use customerId if available, else vendor
  const sender = shipmentDetails?.customerId
    ? {
      name: shipmentDetails?.customerId?.customerUser?.name || "Customer",
      phone: shipmentDetails?.customerId?.customerUser?.phone || "",
      address: shipmentDetails?.customerId?.customerUser?.address || "",
    }
    : {
      name: shipmentDetails?.vendor?.shopName || "Sender",
      phone: shipmentDetails?.vendor?.phone || "",
      address: shipmentDetails?.vendor?.address || "",
    };

  const invoiceData = {
    invoiceNo: shipmentDetails?.shipmentId,
    customer: {
      name: shipmentDetails?.vendor?.shopName || "Vendor",
    },
    sender: {
      name: sender?.name,
      address: shipmentDetails?.sender?.address || "Address",
      phone: shipmentDetails?.sender?.phone || "XXX",
    },
    receiver: {
      name: shipmentDetails?.receiver?.customerUser?.name || "Receiver",
      address: shipmentDetails?.receiver?.address || "Address",
      phone: shipmentDetails?.receiver?.phone || "",
    },
    from: shipmentDetails?.sourceBranch?.name,
    to: shipmentDetails?.destinationBranch?.name,
    fromDistrict: shipmentDetails?.sourceBranch?.district?.name,
    toDistrict: shipmentDetails?.destinationBranch?.district?.name,
    weight: shipmentDetails?.weight
      ? `${shipmentDetails.weight} Kg`
      : shipmentDetails?.unit?.value && shipmentDetails?.unit?.unitType?.name
        ? shipmentDetails.unit.unitType.name.toLowerCase() === "weight"
          ? `${shipmentDetails.unit.value} Kg`
          : `${shipmentDetails.unit.value} ${shipmentDetails.unit.unitType.name}`
        : "N/A",
    createdDate: shipmentDetails?.createdAt,
    printTime: new Date().toLocaleString("en-US", {
      dateStyle: "medium",
      timeStyle: "medium",
    }),
  };



  return (

    <div
      style={{
        fontFamily: "sans-serif",
        width: "210mm",
        height: "297mm",
        boxSizing: "border-box",
        background: "white",
        margin: 0,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          border: "2px solid black",
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            padding: 16,
            borderBottom: "2px solid black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ flex: "0 0 auto", marginRight: "16px" }}>
            <img
              src={shipment?.entity?.logo?.url || "/logonew.png"}
              alt="Logo"
              style={{ height: "60px" }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
              }}
            >
              <span style={{ fontSize: 22, fontWeight: "bold" }}>
                Proof of Receipt
              </span>
            </div>
            <div style={{ fontSize: 14, textAlign: "center", marginTop: 4 }}>
              {shipmentDetails?.entity?.displayName}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", borderBottom: "1px solid #ccc" }}>
          <div style={{ flex: 1, padding: 16 }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              From:
            </div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: 18,
                marginBottom: 2,
              }}
            >
              {invoiceData.from}
            </div>
            {invoiceData.fromDistrict && (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginBottom: 6,
                }}
              >
                {invoiceData.fromDistrict}
              </div>
            )}
            <div style={{ fontSize: 16, fontWeight: "bold" }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Name:</strong> {invoiceData.sender.name}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Phone:</strong> {shipmentDetails?.vendor?.phone}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Address:</strong> {shipmentDetails?.vendor?.address}
              </div>
            </div>
          </div>
          <div style={{ flex: 1, padding: 16, borderLeft: "1px solid #ccc" }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              To:
            </div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: 18,
                marginBottom: 2,
              }}
            >
              {invoiceData.to}
            </div>
            {invoiceData.toDistrict && (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginBottom: 6,
                }}
              >
                {invoiceData.toDistrict}
              </div>
            )}
            <div style={{ fontSize: 16, fontWeight: "bold" }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Name:</strong> {invoiceData.receiver.name}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Phone:</strong> {invoiceData.receiver.phone || ""}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Address:</strong> {invoiceData.receiver.address}
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", borderBottom: "1px solid #ccc" }}>
          <div style={{ flex: 1, padding: 16 }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              Shipment Details
            </div>
            <div style={{ fontSize: 14 }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Shipment ID:</strong> #{invoiceData.invoiceNo}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Shipment Created Date:</strong>{" "}
                {moment(invoiceData.createdDate).format("MM/DD/YYYY")}
              </div>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              padding: 16,
              borderLeft: "1px solid #ccc",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <QRCode value={shipmentDetails?.shipmentId || ""} size={70} />
          </div>
        </div>

        <div style={{ display: "flex", borderBottom: "1px solid #ccc" }}>
          <div style={{ flex: 1, padding: 16 }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              Package Information
            </div>
            <div style={{ fontSize: 14 }}>
              <div style={{ marginBottom: 4 }}>
                <strong>Weight:</strong> {invoiceData?.weight}
              </div>
            </div>
          </div>
          <div style={{ flex: 1, padding: 16, borderLeft: "1px solid #ccc" }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
              Product Details
            </div>
            <div style={{ fontSize: 13 }}>
              <div style={{ marginBottom: 6 }}>
                <strong>Product Description:</strong>{" "}
                {shipmentDetails?.productDescription || "N/A"}
              </div>
              <div style={{ marginBottom: 4 }}>
                <strong>Instruction:</strong>{" "}
                {shipmentDetails?.instruction || "N/A"}
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: 16, borderBottom: "1px solid #ccc" }}>
          <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
            Additional Information
          </div>
          <div style={{ fontSize: 13 }}>
            <div style={{ marginBottom: 6 }}>
              <strong>Received On:</strong>{" "}
              {shipmentDetails?.shipmentPickupTime
                ? moment(shipmentDetails?.shipmentPickupTime).format(
                  "MM/DD/YYYY hh:mm A"
                )
                : ""}
            </div>
          </div>
        </div>

        <div
          style={{
            borderTop: "2px solid black",
            textAlign: "center",
            padding: 10,
            fontSize: 14,
            marginTop: "auto",
          }}
        >
          Thank you for choosing our logistics service.
        </div>
      </div>
      <style>
        {`
            @media print {
              html, body, #shipping-label, #shipping-label > div {
                width: 210mm !important;
                height: 297mm !important;
                min-width: 210mm !important;
                min-height: 297mm !important;
                max-width: 210mm !important;
                max-height: 297mm !important;
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box !important;
                background: white !important;
              }
              @page {
                size: A4 portrait;
                margin: 0;
              }
            }
          `}
      </style>
    </div>
  );
};

export const generatePORPrint = (orderDetail) => {
  const labelWindow = window.open("", "_blank");
  if (!labelWindow) {
    console.error("Failed to open new window for printing");
    return;
  }
  labelWindow.document.write(`
        <html>
        <head>
            <title>Proof of Receipt</title>
            <style>
                @media print {
                    body * { visibility: hidden; }
                    #shipping-label, #shipping-label * { visibility: visible; }
                    #shipping-label { position: absolute; left: 0; top: 0; width: 100%; height: 100%; margin: 0; padding: 0; box-shadow: none; }
                    @page { margin: 0; size: auto; }
                }
            </style>
        </head>
        <body>
            <div id="shipping-label" style="display: flex; justify-content: center; align-items: center;"></div>
        </body>
        </html>
    `);
  labelWindow.document.close();

  setTimeout(() => {
    const qrRoot = labelWindow.document.getElementById("shipping-label");
    if (qrRoot) {
      const labelElement = document.createElement("div");
      qrRoot.appendChild(labelElement);
      try {
        ReactDOM.render(
          <ShipmentPORPrint orderDetail={orderDetail} />,
          labelElement
        );
      } catch (error) {
        console.error("ReactDOM.render error:", error);
      }
    } else {
      console.error("shipping-label element not found");
    }
  }, 100);
};

export default ShipmentPORPrint;


